import {
    acceptedCategory,
    hide,
    hidePreferences,
    run,
    setLanguage,
    showPreferences,
} from 'vanilla-cookieconsent';

/** Named API wrapper — CRA/webpack exposes only named exports from this package. */
export const CookieConsent = {
    acceptedCategory,
    hide,
    hidePreferences,
    run,
    setLanguage,
    showPreferences,
};

let initPromise: Promise<void> | null = null;

/** Resolves when CookieConsent.run() has finished (ConsentManager calls this). */
export function markConsentInitialized(promise: Promise<void>): void {
    initPromise = promise;
}

/**
 * Opens the cookie preferences modal (footer link + banner "Manage preferences").
 */
export async function openCookiePreferences(): Promise<void> {
    if (initPromise) {
        try {
            await initPromise;
        } catch {
            console.error('[CookieConsent] Cannot open preferences — init failed.');
            return;
        }
    }

    if (typeof showPreferences !== 'function') {
        console.warn('[CookieConsent] showPreferences unavailable.');
        return;
    }

    const root = document.getElementById('cc-main');
    if (!root) {
        console.warn('[CookieConsent] Plugin root (#cc-main) not found.');
        return;
    }

    hide();
    hidePreferences();
    showPreferences();
}
